import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import updateMutation from './mutation-update.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(updateMutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    if (!value.name || !value.description) return true

    let mutationResponse = await executeMutation({
      id: value.id,
      procedure: {
        name: value.name,
        description: value.description,
        requires_diagnosis: value.requires_diagnosis,
        requires_images: value.requires_images,
      },
      charges: value.charge_ids.map(misc_fee_charge_template_id => ({
        procedure_id: value.id,
        misc_fee_charge_template_id,
      })),
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while updating procedure.`))
      return
    }

    notify(notifySuccess(`Procedure has been updated.`))

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
